import { styled } from '@mui/material/styles';
import { MainSection as BaseMainSection } from 'components/styledComponents';
import loginImage from './images/login.jpg';
import registerImage from './images/register.jpg';
import Logo from 'components/Logo';

/* Container: filter out "transparent" prop */
export const Container = styled('div', {
  shouldForwardProp: prop => prop !== 'transparent'
})(({ theme, transparent }) => ({
  background: transparent ? theme.color.background.transparent : theme.color.background.transparent,
  borderRadius: theme.borderRadius.base,
  zIndex: theme.layer.above
}));

/* MainSection: filter out "isRegisterPage" prop */
export const MainSection = styled(BaseMainSection, {
  shouldForwardProp: prop => prop !== 'isRegisterPage'
})(({ theme, isRegisterPage }) => ({
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  background: isRegisterPage
    ? `center / cover no-repeat url(${registerImage})`
    : `center / cover no-repeat url(${loginImage})`,

  "svg[old='1']": {
    fontSize: theme.fontSize.xlarge,
    left: '5%',
    position: 'absolute',
    top: '5%',
    '@media (max-width: 446px)': {
      top: '10%'
    }
  }
}));

export const CornerLogo = styled(Logo)({
  height: '88px',
  right: '1%',
  position: 'absolute',
  top: '1%',
  width: '232px'
});
